import { Routes, Route } from "react-router-dom";
import Home from "../Sections/Home";
import AboutUs from "../Sections/AboutUs";
import Services from "../Sections/Services";
import OurWork from "../Sections/OurWork";
import Client from "../Sections/ClientTestimonial";
import FAQs from "../Sections/FAQ";
import ContactUs from "../Sections/ContactUs";

function AppRoutes() {
  return (
    <Routes>
      {/* Home page with all sections */}
      <Route
        path="/"
        element={
          <>
            <Home />
            <AboutUs />
            <Services />
            <OurWork />
            <Client />
            <FAQs />
          </>
        }
      />

      {/* Contact Us standalone page */}
      <Route path="/ContactUs" element={<ContactUs />} />
    </Routes>
  );
}

export default AppRoutes;
